export default __webpack_public_path__ + "static/media/loading.00483141.gif";